import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Globe2, KeyRound, BookOpen, Inbox } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { WebsiteBookingsTab } from '../components/direct/WebsiteBookingsTab';
import { WebsiteRequestsTab } from '../components/direct/WebsiteRequestsTab';
import { ApiKeysTab } from '../components/direct/ApiKeysTab';
import { DeveloperDocsTab } from '../components/direct/DeveloperDocsTab';

export default function DirectBookings() {
  const { isAdmin } = useAuth();
  return (
    <div data-testid="direct-bookings-page">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-stone-900 font-['Manrope'] tracking-tight">Direct Bookings</h1>
        <p className="text-stone-500 mt-1">Bookings from your website, plus API keys to connect it</p>
      </div>
      <Tabs defaultValue="bookings">
        <TabsList className="mb-5 bg-sage-50 border border-sage-100">
          <TabsTrigger value="bookings" data-testid="tab-website-bookings"><Globe2 className="w-4 h-4 mr-1.5" />Website Bookings</TabsTrigger>
          <TabsTrigger value="requests" data-testid="tab-website-requests"><Inbox className="w-4 h-4 mr-1.5" />Website Requests</TabsTrigger>
          {isAdmin && <TabsTrigger value="keys" data-testid="tab-api-keys"><KeyRound className="w-4 h-4 mr-1.5" />API Keys</TabsTrigger>}
          <TabsTrigger value="docs" data-testid="tab-developer-docs"><BookOpen className="w-4 h-4 mr-1.5" />Developer Docs</TabsTrigger>
        </TabsList>
        <TabsContent value="bookings"><WebsiteBookingsTab /></TabsContent>
        <TabsContent value="requests"><WebsiteRequestsTab /></TabsContent>
        {isAdmin && <TabsContent value="keys"><ApiKeysTab /></TabsContent>}
        <TabsContent value="docs"><DeveloperDocsTab /></TabsContent>
      </Tabs>
    </div>
  );
}
